import { render, staticRenderFns } from "./InvestorPriorities.vue?vue&type=template&id=4fed6bde"
import script from "./InvestorPriorities.vue?vue&type=script&lang=js"
export * from "./InvestorPriorities.vue?vue&type=script&lang=js"
import style0 from "./InvestorPriorities.vue?vue&type=style&index=0&id=4fed6bde&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports